// src/hooks/useClosedDates.js
import { useState, useEffect, useCallback } from 'react';
import bookingService from '../services/bookingService';

export function useClosedDates(salonId) {
  const [closedDates, setClosedDates] = useState([]);
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState(null);

  useEffect(() => {
    if (!salonId) return;

    setLoading(true);
    setError(null);

    bookingService.getClosedDates(salonId)
      .then(data => {
        if (data.success) setClosedDates(data.closedDates);
      })
      .catch(() => setError('Impossible de vérifier les disponibilités'))
      .finally(() => setLoading(false));
  }, [salonId]);

  // true si la date est fermée — accepte string "YYYY-MM-DD" ou objet Date
  const isDateDisabled = useCallback((date) => {
    if (!date) return false;
    const str = typeof date === 'string'
      ? date
      : date.toISOString().split('T')[0];
    return closedDates.includes(str);
  }, [closedDates]);

  // Message à afficher quand la date choisie est fermée
  const getClosureMessage = useCallback((dateStr) => {
    if (!dateStr || !closedDates.includes(dateStr)) return null;
    return "Fermeture exceptionnelle — le salon n'est pas disponible à cette date.";
  }, [closedDates]);

  return { closedDates, isDateDisabled, getClosureMessage, loading, error };
}